import React from 'react';
import { Grid } from '@material-ui/core';
import TableComponents from 'components/Table';
import Forms from 'components/Forms';
import { Button, BoxWrapper } from 'components/Base';
import { formatCurrency } from 'utils';

interface ContributionsProps {
  fields: any;
  hasExistingPolicies: boolean;
}

const Contributions = ({ fields, hasExistingPolicies }: ContributionsProps) => {
  const fieldsLength = fields.getAll().length;

  return (
    <BoxWrapper
      title="New / Unallocated money"
      tooltip="Specify gross amount i.e. pension contributions"
      headerChildren={
        <Grid
          item
          xs={12}
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          {hasExistingPolicies && (
            <Button
              type="button"
              onClick={() =>
                fields.unshift({
                  owner: null,
                  amount: formatCurrency(0),
                  frequency: null,
                  source: null,
                  allocate_to: null,
                  new_money: true
                })
              }
            >
              Allocate existing money
            </Button>
          )}
          <Button
            style={{ marginLeft: '1rem' }}
            type="button"
            onClick={() =>
              fields.unshift({
                owner: null,
                amount: formatCurrency(0),
                frequency: null,
                source: null,
                allocate_to: null,
                new_money: true
              })
            }
          >
            Add money
          </Button>
        </Grid>
      }
    >
      {fieldsLength > 0 && (
        <TableComponents.Table>
          <TableComponents.TableHead
            cells={[
              'Policy owner(s)',
              'Amount',
              'Frequency',
              'Source',
              'Allocation'
            ]}
          />
          <TableComponents.TableBody>
            {fields.map((field: any, index: number) => {
              const contributionValues = fields.get(index);
              return (
                <Forms.Contribution
                  contribution={field}
                  key={index}
                  contributionValues={contributionValues}
                />
              );
            })}
          </TableComponents.TableBody>
        </TableComponents.Table>
      )}
    </BoxWrapper>
  );
};

export default Contributions;
